import {Component} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import Localization from 'src/smoothr-web-app-core/models/Localization';

@Component({
	selector: 'app-favourite-modal-on-add',
	templateUrl: './favourite-modal-on-add.component.html',
	styleUrls: ['./favourite-modal-on-add.component.scss']
})
export class FavouriteModalOnAddComponent {
	name: Localization;
	constructor(
		private modalCtrl: ModalController,
		private translate: TranslateService
	) {}

	static async show(modalCtrl: ModalController, name: Localization): Promise<void> {
		const modal = await modalCtrl.create({
			component: FavouriteModalOnAddComponent,
			cssClass: 'favourite-modal-on-add auto-height',
			componentProps: {
				name
			},
			showBackdrop: true,
			backdropDismiss: true
		});
		await modal.present();
		await modal.onDidDismiss();
	}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
